import { render, staticRenderFns } from "./count-summary.component.vue?vue&type=template&id=1ca352d6"
import script from "./count-summary.component.ts?vue&type=script&lang=ts&external"
export * from "./count-summary.component.ts?vue&type=script&lang=ts&external"
import style0 from "./count-summary.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports